/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { WidgetV2 } from '../../../../../components/v2';
import { montarGrupos, montarResumo } from './camposInspecao';

const VAZIO = '—';

const COLUNAS_SX = {
  display: 'grid',
  gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', md: 'repeat(4, minmax(0, 1fr))' },
  columnGap: 2,
  rowGap: 1,
};

const InformacoesCampoSecao = ({ values }) => {
  const resumo = montarResumo(values);
  const grupos = montarGrupos(values);
  const resumoTexto = resumo.map((item) => `${item.nome} ${item.valor}`).join(' · ');
  return (
    <WidgetV2
      collapse
      initialExpanded={false}
      title="Informações de campo"
      subheader={resumoTexto || undefined}
    >
      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1.5, bgcolor: 'background.paper' }}>
        {grupos.map((grupo) => (
          <Box key={grupo.titulo}>
            <Typography variant="overline" color="text.secondary" sx={{ display: 'block', lineHeight: 1.8 }}>
              {grupo.titulo}
            </Typography>
            <Box sx={COLUNAS_SX}>
              {grupo.campos.map((campo) => (
                <Box
                  key={campo.nome}
                  sx={{
                    minWidth: 0,
                    gridColumn: {
                      xs: campo.span > 1 ? 'span 2' : 'span 1',
                      md: `span ${campo.span || 1}`,
                    },
                  }}
                >
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                    {campo.nome}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 500,
                      overflowWrap: 'anywhere',
                      whiteSpace: campo.multilinha ? 'pre-wrap' : 'normal',
                      color: campo.valor ? 'text.primary' : 'text.secondary',
                    }}
                  >
                    {campo.valor || VAZIO}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        ))}
      </Box>
    </WidgetV2>
  );
};

InformacoesCampoSecao.propTypes = {
  values: PropTypes.object.isRequired,
};

export default InformacoesCampoSecao;
